import script from "./RoleFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./RoleFormDialog.vue?vue&type=style&index=0&id=df7599fe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df7599fe"]])

export default __exports__